/**
 * This error occurs when you try to pass some wrong item
 *
 * @collboard-modules-sdk
 */
export class InvalidError extends TypeError {
    public readonly name = 'InvalidError';
}
